import * as React from "react";
import { Context } from "./_context";
export const CategoryDepartmentStoreIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 7.5h-4.987L8.312 19.584A1 1 0 0 1 7.5 20H2v-2h2.064l.261-3.907.017-.189a3.849 3.849 0 0 1 6.92-1.84L15.39 6.33l.15-.185c.376-.41.91-.646 1.473-.646H22v2Zm-13.835 5a1.85 1.85 0 0 0-1.824 1.546l-.02.18L6.068 18h.92l2.963-4.117A1.848 1.848 0 0 0 8.165 12.5ZM8 4a2.75 2.75 0 1 1 0 5.5A2.75 2.75 0 0 1 8 4Zm0 2a.75.75 0 1 0 0 1.5A.75.75 0 0 0 8 6Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryDepartmentStoreIcon.iconId = "BiB43w";
